import { updateEvent, deleteEvent, batches } from './store'
const nanoid = require('nanoid')

export const updateEventResultCode = async (userId, events, index, resultCode, batchId) => {
  const eventId = events[index].key
  if (resultCode === 200) {
    return deleteEvent(userId, eventId)
  }
  events[index].value.ResultCode = resultCode
  events[index].value.BatchId = batchId
  return updateEvent(userId, eventId, events[index].value)
}

export const updateEventResponse = async (userId, events, pendingEvents, response) => {
  var promises = []
  if (response !== undefined) {
    if (pendingEvents.length > 1) {
      if (response) {
        response.forEach(element => {
          var index = pendingEvents[element.eventIndex].originalIndex
          promises.push(updateEventResultCode(userId, events, index, element.resultCode, undefined))
        })
      } else {
        // If the batch failed clear the batchId so we can try again
        pendingEvents.forEach(element => {
          promises.push(updateEventResultCode(userId, events, element.originalIndex, 0, undefined))
        })
      }
    } else {
      const resultCode = response === '' ? 200 : 400
      var index = pendingEvents[0].originalIndex
      promises.push(updateEventResultCode(userId, events, index, resultCode, undefined))
    }
    await Promise.all(promises)
  }
}

export const updateEventsBatchId = async (userId, events, pendingEvents) => {
  var promises = []
  var batchId = nanoid()
  batches.push(batchId)
  pendingEvents.forEach(element => {
    events[element.originalIndex].value.BatchId = batchId
    promises.push(updateEvent(userId, events[element.originalIndex].key, events[element.originalIndex].value))
  })
  await Promise.all(promises)
}
